import Grid from '@mui/material/Grid';
import WbSunnyIcon from '@mui/icons-material/WbSunny';
import { Divider, Typography } from '@mui/material';
import WbTwilightIcon from '@mui/icons-material/WbTwilight';
import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import * as React from 'react';

let StyledPaper = styled(Paper)(({ theme }) => ({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    maxWidth: '145px',
    maxHeight: '100%',
    padding: '2px 9px 2px 9px',
    border: '1px solid rgba(0, 0, 0, 0.12)',
    boxShadow: 'none'
}));

let IconGrid = styled(Grid)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    padding: '8px'
}));

const SunriseSunsetSection = ({ sunrise, sunset, labels }) => {
    return (
        <Grid item xs={6}>
            <StyledPaper>
                <IconGrid item sx={{ paddingRight: '15px' }}>
                    <WbSunnyIcon
                        sx={{
                            color: '#FFB547',
                            width: 'auto',
                            height: '30px',
                            paddingTop: '3px',
                            paddingRight: '3px'
                        }}
                    />
                    {sunrise ? (
                        <Typography
                            aria-label="sunrise-time"
                            sx={{
                                fontSize: '12px',
                                fontFamily: 'Roboto',
                                lineHeight: '19px',
                                fontWeight: 400
                            }}
                        >
                            {sunrise}
                        </Typography>
                    ) : (
                        <Typography sx={{ textAlign: 'center', fontSize: '9px' }}>
                            {labels.notAvailable}
                        </Typography>
                    )}
                </IconGrid>
                <Divider
                    orientation="vertical"
                    variant="middle"
                    flexItem
                    sx={{
                        height: '46px',
                        position: 'absolute'
                    }}
                />
                <IconGrid item sx={{ paddingLeft: '15px' }}>
                    <WbTwilightIcon
                        color="warning"
                        sx={{
                            width: 'auto',
                            height: '30px'
                        }}
                    />
                    {sunset ? (
                        <Typography
                            aria-label="sunset-time"
                            sx={{
                                fontSize: '12px',
                                fontFamily: 'Roboto',
                                lineHeight: '19px',
                                fontWeight: 400
                            }}
                        >
                            {sunset}
                        </Typography>
                    ) : (
                        <Typography sx={{ textAlign: 'center', fontSize: '9px' }}>
                            {labels.notAvailable}
                        </Typography>
                    )}
                </IconGrid>
            </StyledPaper>
        </Grid>
    );
};

export default SunriseSunsetSection;
